// @flow

import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';

import supportIcon from '../../../../assets/img/support-icon.svg';
import {colors} from '../../../../assets/styles/colors';
import {TIENDADA_LINKS} from '../../../../constants';
import {useSidebarContext} from '../SidebarContainer';

type Props = {};

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textDecoration: 'none',
    marginTop: '2.5rem',
  },
  mainText: {
    fontWeight: 600,
    fontSize: 14,
    color: colors.purple,
    textAlign: 'center',
  },
  secondaryText: {
    fontSize: 14,
    color: colors.grey700,
    textAlign: 'center',
  },
}));

export default function ContactSupport(props: Props) {
  const classes = useStyles();

  const {shrink} = useSidebarContext();

  if (shrink) return null;

  return (
    <a
      href={TIENDADA_LINKS.customerSupport.general}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.root}
    >
      <img src={supportIcon} alt="" />
      <Typography className={classes.mainText}>Necesitas ayuda</Typography>
      <Typography className={classes.secondaryText}>
        Habla con nuestro equipo
        <br /> de soporte.
      </Typography>
    </a>
  );
}

ContactSupport.propTypes = {};
